import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { Observable, ObservableInput } from 'rxjs/Observable';
import { SharedService } from '../shared/shared.service';
import { environment } from '../../environments/environment';
import { ListRooms } from './chat/list/listroom';
import {LOCAL_STORAGE, WebStorageService} from 'angular-webstorage-service';


@Injectable()

export class DashboardService {   

  public baseUrl: string; 
  public id_room: string;


  handleError: (err: any, caught: Observable<Blob>) => ObservableInput<Blob>;

  constructor(  
    private _http: Http,
    private _data: SharedService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {
    this.baseUrl = environment.apiUrl;   
  }

  listRoom(data: any): Observable<ListRooms> {  
    let json = JSON.stringify(data);
    let filtro = data.filtro != null ? '&filtro=' + data.filtro : '';
    let fechaDesde = data.fechaDesde != null ? '&fechaDesde=' + data.fechaDesde : '';
    let fechaHasta = data.fechaHasta != null ? '&fechaHasta=' + data.fechaHasta : '';
    let soloVariable = '&soloVariable=' + data.soloVariable;
    let dataEnv = data.user_id != null ? '?user_id='+ data.user_id + '&list_type=' + data.list_type + filtro + fechaDesde + fechaHasta + soloVariable : '?list_type=' + data.list_type + filtro + fechaDesde + fechaHasta + soloVariable;
    
    //console.log("Esto es lo que se le envía al room: ", data);
    //let user2 = this.storage.get('Usuario').id;
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this._http.get(this.baseUrl + 'room' + dataEnv, {headers: headers}).map(res => res.json());
  }

  getRoomMsgs(data: any) {   
    let json = JSON.stringify(data.user_id);
    let user_id = data.user_id != null ? '?user_id='+data.user_id : '';
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    //console.log("Data: ", data);
    //console.log("Esto es lo que se le envía: ", JSON.stringify(data));
    //return this._http.get(this.baseUrl + 'room/' + this.id_room + '/messages'+ user_id, {headers: headers}).map(res => res.json());
    return this._http.get(this.baseUrl + 'room/' + data.room_id + '/messages'+ user_id, {headers: headers}).map(res => res.json());
  }

  newMsgs(data: any) { 
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this._http.post(this.baseUrl + 'room/change-status-read-message', json, { headers: headers })
      .map(res => res.json());
  }

  getStatusControl(data: any) {
    let json = JSON.stringify(data); 
    //console.log(json);
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this._http.post(this.baseUrl + 'monitor/status-take-control', json, {headers: headers}).map(res => res.json());
  }

  takeStatusControl(data: any) {
    let json = JSON.stringify(data);
    //console.log(json);
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    return this._http.post(this.baseUrl + 'monitor/take-control', json, {headers: headers}).map(res => res.json());
  }

  roomId(id) {
    return this.id_room = id;
  }

  uploadfiles(file: any) {
    let json = JSON.stringify(file);
    const formData = new FormData();
    formData.append('file', file);
    const headers = new Headers({});
    //console.log("Esto es lo que se envía: ", file);
    headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));
    //headers.append('Content-Type', 'multipart/form-data'); da error al enviar la cabecera para los archivos
    return this._http.post(this.baseUrl + 'room/' + this.id_room + '/add-attachment',
    formData, { headers: headers }).map(res => res.json());
  }

  downloadFile(url): Observable<Blob> {
    console.log("Esta es la url: ", url);
    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this._http.get(url, options).map(res => res.blob()).catch(this.handleError);
  }

  login(login: any) { // login service
    let json = JSON.stringify(login);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this._http.post(this.baseUrl + 'login', json, { headers: headers })
      .map(res => res.json());
  }

  getCurrent(data: any) {
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.get(this.baseUrl + 'user/current', { headers: headers })
      .map(res => res.json());
  }

  sendMessage(data: any) {
    let json = JSON.stringify(data);
    let user_id = data.user_id != null ? '?user_id='+data.user_id : '';
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'room/' + data.room + '/messages'+ user_id, json, {headers: headers})
              .map(res => res.json());
  }

  sendComments(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'room/' + data.room + '/comments', json, {headers: headers})
              .map(res => res.json());
  }

  deleteComments(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'room/' + data.room + '/delete-comments', json, {headers: headers})
              .map(res => res.json());
  }

  logout(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);

    return this._http.post(this.baseUrl + 'user/logout', json, { headers: headers })
      .map(res => res.json());
  }

  toggleStatus(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));

    return this._http.post(this.baseUrl + 'user/online', json, { headers: headers })
      .map(res => res.json());
  }

  changeRoomStatus(data: any) {  
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));

    return this._http.post(this.baseUrl + 'room/' + this.id_room + '/status-change', json, { headers: headers })
      .map(res => res.json());
  }

  //Agregar tags

  addTags(data: any, data2: any) {  

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));

    return this._http.post(this.baseUrl + 'room/' + 'add-tags'+'?idRooms='+ data2 +'&idTags='+ data, { headers: headers })
      .map(res => res.json());
  }

  //Eliminar tags
  delTags(data: any) {  
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));

    return this._http.post(this.baseUrl + 'room/' + this.id_room + '/delete-tags', json, { headers: headers })
      .map(res => res.json());
  }

  // Change Password

  changePassword(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.token);
    return this._http.post(this.baseUrl + 'user/change-password', json, { headers: headers })
      .map(res => res.json());
  }

  // Get Info for report
  public getReportForAgents(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    //console.log("Esto es lo que se le envía al servidor: ", json);
    return this._http.post(this.baseUrl + 'get-info-to-report', data, { headers: headers }).map(res => res.json());
  }

  public getDataReport(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    //console.log("Esto es lo que se le envía al servidor: ", json);
    return this._http.post(this.baseUrl + 'getDataReport', data, { headers: headers }).map(res => res.json()).timeout(180000); // Tiempo en milisegundos;
  }

  public getReportForAgentsExcel(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    //console.log("Esto es lo que se le envía al servidor: ", json);
    return this._http.post(this.baseUrl + 'get-info-to-report-excel', data, { headers: headers }).map(res => res.json());
  }


  public ordenarChats(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    //console.log("Esto es lo que se le envía al servidor: ", json);
    return this._http.post(this.baseUrl + 'room/change-order-chats', data, { headers: headers }).map(res => res.json());
  }

  public roomsPending(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'room/rooms-pending', data, { headers: headers }).map(res => res.json());
  }

  public associationTagsExist(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this._http.post(this.baseUrl + 'roomsTags', data, { headers: headers }).map(res => res.json());
  }

  getVariables(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'room/variables', json, {headers: headers})
              .map(res => res.json());
  }

  public roomsImportant(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    //console.log("Esto es lo que se le envía al servidor: ", json);
    return this._http.post(this.baseUrl + 'rooms-important', data, { headers: headers }).map(res => res.json());
  }

  getTypology(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'room/typology', json, {headers: headers})
              .map(res => res.json());
  }
  
  getTagsLevel1(data: any) {
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'room/tagsLevel', json, {headers: headers})
              .map(res => res.json());
  }

  getHistoryRooms(data: any) {  
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this._data.getCookie('auth_token'));

    return this._http.post(this.baseUrl + 'room/' + this.id_room + '/history-room', json, { headers: headers })
      .map(res => res.json());
  }



  getTagsInRoom = async () => {
    try {
      const response = await fetch(this.baseUrl+'room/tagsRooms'+'?id_rooms='+ this.id_room);
      const data = await response.json();
      
      return data.data
    } catch (error) {
      console.error(error);
    }
  }


  getTagsLevel = async () => {
    try {
      const response = await fetch(this.baseUrl+'room/obtenerTags')
      const data = await response.json();
      
      return data.data
    } catch (error) {
      console.error(error);
    }
  }

  

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/dashboard.service.ts